import type {ReactNode} from 'react'
import {editable} from './constants'

export function Editable({value, onChange}: {value: ReactNode; onChange?: (v: string) => void}) {
  return (
    <span
      contentEditable
      suppressContentEditableWarning
      onBlur={(e) => onChange?.(e.currentTarget.textContent ?? '')}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          e.currentTarget.blur()
        }
      }}
      className={`${editable} inline-block`}
    >
      {value}
    </span>
  )
}

export function MetaPill({filled, label}: {filled: boolean; label: string}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-[12px] font-medium ${
        filled
          ? 'border-green-neon/35 bg-green-neon/15 text-moss-black'
          : 'border-black/[0.08] bg-black/[0.04] text-black/35'
      }`}
    >
      {label}
    </span>
  )
}
